import type { ColDef, RowClassParams } from 'ag-grid-community';
export class GrillaColumns {


  static rowClassRules = {
    'detail-row': (params: RowClassParams) => params.data?.isDetail === true,
  };

    static detalleColumns = [
    { key: 'areaZonaCuadrante', label: 'Area-ZonaCuadrante' },
    { key: 'tipo', label: 'Tipo' },
    { key: 'severidad', label: 'Severidad' },
    { key: 'observacion', label: 'Observación' },
    { key: 'responsable', label: 'Responsable' },
    { key: 'clasificacion', label: 'Clasificación' },
    { key: 'codificacion', label: 'Codificación' },
  ];

  static getRowHeight(params: any): number | undefined {
    if (params.data?.isDetail) {
      const list = params.data.detailData || [];
      return Math.max(list.length * 50, 1);
    }
    return undefined;
  }


  static getExpandColumn(filasExpandidas: Set<number>, ctx: any): ColDef {
    return {
      headerName: '',
      field: 'expand',
      width: 50,
      colSpan: (params) => (params.data?.isDetail ? 1 : 1),
      cellRenderer: (params: RowClassParams) => {
       //console.log(params.data?.datosAverias)
        //if (!params.data?.datosAverias || params.data.datosAverias.length === 0) return '';
         if (!params.data?.datosAverias?.length) return '';
         return params.data.isExpanded
    ? '<span class="material-symbols-outlined" style="font-size: 17px; color:#007749">do_not_disturb_on</span>' 
    : '<span class="material-symbols-outlined" style="font-size: 17px; color:#007749">add_circle</span>';
      },
      onCellClicked: (params) => {


        if (!params.data?.datosAverias || params.data.datosAverias.length === 0) return;

          ctx.popupTitulo = 'Detalle de Averías';

         
        const list = params.data.datosAverias || [];
        const columns = GrillaColumns.detalleColumns;
         ctx.popupBody = `<div style="margin:10px ;padding: 0px">
            <table class="detalle-table" border="1" style="width:100%; border-collapse: collapse; border-color: white;">
              <thead class="detalle-table-thead">
                <tr>
                  ${columns.map(col => `<th>${col.label}</th>`).join('')}
                </tr>
              </thead>
              <tbody class="detalle-table-body">
                ${list
                  .map(
                    (item: any, idx: number) =>
                      `<tr style="height:10px; background-color: ${idx % 2 === 0 ? '#F2F2F2' : 'white'};">
                        ${columns.map(col => `<td>${item[col.key] ?? ''}</td>`).join('')}
                      </tr>`
                  )
                  .join('')}
              </tbody>
            </table>
          </div>`;

            // ctx.popupBody = params.data.datosAverias.map((d: any) => `
            //   <div style="margin-bottom:10px; border-bottom:1px solid #ddd; padding-bottom:5px;">
            //     <strong>Area ZonaCuadrante:</strong> ${d.areaZonaCuadrante ?? ''} <br>
            //     <strong>Tipo:</strong> ${d.tipo ?? ''} <br>
            //     <strong>severidad:</strong> ${d.severidad ?? ''}
            //     <strong>observacion:</strong> ${d.observacion ?? ''}
            //     <strong>Fecha:</strong> ${d.severidad ?? ''}
            //     <strong>Responsable:</strong> ${d.responsable ?? ''}
            //     <strong>Clasificacion:</strong> ${d.clasificacion ?? ''}
            //     <strong>Codificacion:</strong> ${d.codificacion ?? ''}
            //   </div>
            // `).join('');



            ctx.mostrarPopup = true;
  

        return;

        if (!params.data?.datosAverias || params.data.datosAverias.length === 0) return;
        const row = params.data;
        const wasExpanded = !!row.isExpanded;
       
        params.api.forEachNode((node) => {
          if (node.data && node.data.isExpanded) {
            node.data.isExpanded = false;
            const allRows: any[] = [];
            params.api.forEachNode((n) => allRows.push(n.data));
            const toRemove = allRows.find(
              (r) => r.isDetail && r.parentId === node.data.id
            );
            if (toRemove) {
              params.api.applyTransaction({ remove: [toRemove] });
            }
          }
        });

        if (!wasExpanded) {
          row.isExpanded = true;
          filasExpandidas.add(row.id); //agregado
          const index = params.node.rowIndex ?? 0;

          const nuevasFilas = [];

          nuevasFilas.push({
                isDetail: true,
                parentId: row.id,
                detailData: row.datosAverias,
          });

          params.api.applyTransaction({
              add: nuevasFilas,
              addIndex: index + 1,
            });
          params.api.redrawRows({ rowNodes: [params.node] });
//  params.api.redrawRows();
            //ORIGINAL
            // params.api.applyTransaction({
            //   add: [{
            //     isDetail: true,
            //     parentId: row.id,
            //     detailData: row.datosAverias,
            //   }],
            //   addIndex: index + 1,
            // });



          // const detailRow = {
          //   isDetail: true,
          //   parentId: row.id,
          //   detailData: row.datosAverias,//detailsList,
          // };
          // params.api.applyTransaction({
          //   add: [detailRow],
          //   addIndex: index + 1,
          // });
        } else {
          row.isExpanded = false;
          filasExpandidas.delete(row.id);
          const allRows: any[] = [];
          params.api.forEachNode((node) => allRows.push(node.data));
          const toRemove = allRows.find(
            (r) => r.isDetail && r.parentId === row.id
          );
          if (toRemove) {
            params.api.applyTransaction({ remove: [toRemove] });
          }
        }
      params.api.refreshCells({ force: true }); 
       params.api.redrawRows();
      //params.api.redrawRows({ rowNodes: [params.node] });


      //   params.api.refreshCells({
      //   force: true,
      //   columns: ['details'], // el field de tu columna detalle
      //   rowNodes: [params.node] // o el nodo que quieras refrescar
      // });
      },
    };
  }

  static getDetalleColumn(): ColDef {
    return {
      headerName: 'Detalle',
      field: 'details',
      colSpan: (params) => (params.data?.isDetail ? 9: 1),
      cellRenderer: (params: RowClassParams) => {
        if (!params.data?.isDetail) return '';
        // if(!(params.data?.datosAverias.length >0)) return;
        const list = params.data.detailData || [];
        const columns = GrillaColumns.detalleColumns;
        return `
          <div style="margin:10px ;padding: 0px">
            <table class="detalle-table" border="1" style="width:100%; border-collapse: collapse; border-color: white;">
              <thead style="background-color: #BFBFBF;">
                <tr>
                  ${columns.map(col => `<th>${col.label}</th>`).join('')}
                </tr>
              </thead>
              <tbody>
                ${list
                  .map(
                    (item: any, idx: number) =>
                      `<tr style="height:10px; background-color: ${idx % 2 === 0 ? '#F2F2F2' : 'white'};">
                        ${columns.map(col => `<td>${item[col.key] ?? ''}</td>`).join('')}
                      </tr>`
                  )
                  .join('')}
              </tbody>
            </table>
          </div>`;

      },
  autoHeight: true,
  width: 0,
  minWidth: 0,
  maxWidth: 0,
  resizable: false,
  suppressSizeToFit: true,
  headerClass: 'ocultar-header-detalle'
    };
  }
}